<template>
  <div class="footer mainFooter">
    <div class="row py-4">
      <div class="col-6 text-right foot_left pr-10">
        <div>กองบัญชาการตำรวจสอบสวนกลาง</div>
        <div>Central Investigation Bureau</div>
      </div>
      <div class="col-6 text-left foot_right flex-md-row flex-column">
        <img src="/logo-2.png" height="60" width="auto" alt="E-learning" />
        <b class="text-center" style="font-size: 18px; color: #ffd300"
          >ระบบบริหารจัดตารางฝึกอบรมออนไลน์</b
        >
      </div>
    </div>
    <div class="foot_cookie">
      <a href="javascript:void(0)" @click="openCookieSettings">ตั้งค่าคุกกี้</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainFooter",
  data() {
    return {};
  },
  methods: {
    openCookieSettings() {
      this.$root.$emit("open-cookie-settings");
    },
  },
};
</script>
<style lang="scss">
@import "/src/assets/scss/style.scss";

.mainFooter {
  background: #0f3051;
  text-align: center;
}

.foot_left {
  color: white;
  border-right: 2px solid white;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.foot_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.foot_cookie {
  padding-bottom: 12px;

  a {
    color: #ffffff;
    font-size: 13px;
    text-decoration: underline;
    opacity: 0.85;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
